import React, { useState } from 'react';
import axios from 'axios';
import { Col, Row } from 'reactstrap';

function ForgotPassword() {
	const [email, setEmail] = useState('');
	const [status, setStatus] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const BASE_URL =
		window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://dlqw5ngx5xpnk.cloudfront.net';

	const handleChange = (e) => {
		setEmail(e.target.value);
		setError('');
		setStatus('');
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setStatus('');
		setError('');
		setLoading(true);
		try {
			const res = await axios.post(`${BASE_URL}/api/auth/forgot-password`, { email });
			setStatus(res.data.message || 'Check your email for reset instructions.');
		} catch (err) {
			setError(err.response?.data?.message || 'Something went wrong. Please try again.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container">
			<Row>
				<Col xl="12">
					<h2 className="personalinfo_head2">Fellowship Application</h2>
				</Col>
			</Row>
			<Row>
				<Col xl="4">
					<div className="formbg">
						<h3>Forgot Password</h3>
						<form onSubmit={handleSubmit}>
							<div className="form-floating mb-3 mt-3">
								<input
									type="email"
									className="form-control form_cap form_custom"
									id="email"
									placeholder="Enter Email*"
									name="email"
									value={email}
									onChange={handleChange}
									required
								/>
								<label htmlFor="email">
									Email <span className="text-danger">*</span>
								</label>
							</div>
							<button className="login_btn" type="submit" disabled={loading}>
								{loading ? 'Sending...' : 'Send Reset Link'}
							</button>
							{error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
							{status && <div style={{ color: 'green', marginTop: 10 }}>{status}</div>}
						</form>
					</div>
				</Col>
				<Col xl="8">
					<div className="login_content">
						<h4>Fellowship Application Timeline</h4>
						<h5>Deadline </h5>
						<p>
							Completed applications must be submitted by <span>December 10, 2025.</span>
						</p>
						<h5>Selection</h5>
						<p>
							Applicants will be notified of their acceptance status by <span>December 24, 2025.</span>
						</p>
						<p>
							Selected applicants must confirm their acceptance of the fellowship offer by{' '}
							<span>December 31, 2025.</span>
						</p>
						<h5>Commencement</h5>
						<p>
							The fellowship officially begins on <span>January 1, 2026.</span>
						</p>
						<p>
							We encourage meaningful voices to join us in contributing to and enriching the narrative surrounding
							India's journey forward!
						</p>
					</div>
				</Col>
			</Row>
		</div>
	);
}

export default ForgotPassword;
